// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import ESGRouter from '@/features/energyxplorer/components/esg/ESGRouter';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/esg',
)({
  component: ESGRouter,
});
